const welcome = {
    title: '欢迎来到管理控制台',
    description: '管理控制台是一个无需代码操作的应用。你可以用它来管理登录体验。让我们首先创建一个帐号。你可以用它以个人或公司的身份管理 Logto。',
    create_account: '创建帐号',
};
export default welcome;
